import React, { useEffect, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { CtaButtons } from "components/header/cta-buttons";
import { LogoPopover } from "components/header/logo-popover";
import { Container } from "ui/container";
import { remCalc } from "theme/utils";
import { useColorTheme } from "contexts/color-theme";
import { useHeaderHeight } from "contexts/header-height";
import { useScrollTransparency } from "hooks/use-scroll-transparency";

export type HeaderSimpleProps = {
  isTransparent?: boolean;
};

export function HeaderSimple({ isTransparent }: HeaderSimpleProps) {
  const { bgColor } = useColorTheme();
  const headerHeight = remCalc(92);
  const headerRef = useRef<HTMLDivElement>(null);
  const { setHeaderHeight } = useHeaderHeight();
  const scrolled = useScrollTransparency();

  useEffect(() => {
    const headerObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeaderHeight(entry.contentRect.height);
      }
    });

    if (headerRef.current) {
      headerObserver.observe(headerRef.current);
    }

    return () => {
      headerObserver.disconnect();
    };
  }, [setHeaderHeight]);

  const isNowTransparent = isTransparent && !scrolled;

  return (
    <>
      <Box
        display={isTransparent ? "block" : "none"}
        pos="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        height={headerHeight}
        bg={bgColor}
      />

      <Box
        ref={headerRef}
        as="header"
        layerStyle="header"
        bg={isNowTransparent ? "rgba(255, 255, 255, 0.1)" : bgColor}
        backdropFilter="blur(15px)"
      >
        <Container display="flex" alignItems="center" height={headerHeight} justifyContent="space-between">
          <LogoPopover />
          <CtaButtons hasLogin={false} />
        </Container>
      </Box>
    </>
  );
}
